import { Component, Inject, OnInit } from '@angular/core';
import { MatDialog, MatDialogRef, MAT_DIALOG_DATA } from '@angular/material';
import { Router } from '@angular/router';
import { NgxSpinnerService } from 'ngx-spinner';
import { ToastrService } from 'ngx-toastr';
import { StudentactiveService } from '../../serivce/studentactive.service';
import { TeacherService } from '../../serivce/teacher.service';

@Component({
  selector: 'app-delete-student-active-dialog',
  templateUrl: './delete-student-active-dialog.component.html',
  styleUrls: ['./delete-student-active-dialog.component.css']
})
export class DeleteStudentActiveDialogComponent implements OnInit {

  datas: any;
  constructor(private spinner: NgxSpinnerService,
    public dialogRef: MatDialogRef<any>,
    @Inject(MAT_DIALOG_DATA) public data: any,
    private studentService: StudentactiveService,
    private dialog: MatDialog,
    private router: Router,
    private toastr: ToastrService,
  ) {
    this.datas = data;
  }
  ngOnInit() {
  }
  deleteActive() {
    debugger
    var model = {
      Id: this.datas.model.Id
    }
    this.spinner.show();
    this.studentService.delStudentActive(model).subscribe(res => {
      this.spinner.hide();
      if (res.status == 2) {
        this.toastr.success(res.content, "Thành công");
        this.dialogRef.close();
      }
      else {
        this.toastr.error(res.content, "Thất bại");
      }

    })
  }
  onNoClick() {
    this.dialogRef.close();
  }
}
